import React from "react";
import { Grid, Button, Typography } from "@mui/material";
import { ErrorIcon } from "../Styles/Icons";

const ErrorPage = () => {
  return (
    <Grid
      container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <ErrorIcon />
      <Typography sx={{ fontWeight: 600 }}>
        An unexpected error has occurred. Please try again later or contact our
        support team for assistance.
      </Typography>
      <Grid
        item
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
        }}
      >
        <Button
          size="small"
          variant="contained"
          onClick={() => window.location.reload()}
          sx={{ textTransform: "capitalize", px: 5 }}
        >
          Reload
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            window.location.reload();
            window.location.href = "/";
          }}
          sx={{ textTransform: "capitalize", px: 5 }}
        >
          Hard Reload
        </Button>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
